@if (forecast(); as forecast) {
  @if (forecast.company; as company) {
    <!-- TODO: Remove duplicate styles  -->
    <!-- <app-user-section-access [sectionName]="guardSection()">
    <ng-template> -->
    <div class="forecast-wrapper">
      <app-forecast-earn-info
        class="forecast-info"
        [forecast]="forecast"
        [guardSectionName]="routerFacade.guardSectionName$ | async"
      ></app-forecast-earn-info>

      <mat-divider class="info-chart-splitter" [vertical]="true"></mat-divider>
      <mat-divider class="info-chart-splitter-mobile"></mat-divider>

      <section class="chart-card">
        @defer (when !company.addlPred) {
          <!-- <app-forecast-historical-chart></app-forecast-historical-chart> -->
        } @loading {
          <app-loading class="loading"></app-loading>
        }

        @defer (on immediate) {
          <app-eps-pdf-chart-container
            [ticker]="company.ticker"
            [inRequest]="(companyFacade.epsPdfInRequest$ | async) === true"
            [isDark]="(uiFacade.isDarkTheme$ | async) === true"
            [sectionName]="guardEpsPdfChart()"
          ></app-eps-pdf-chart-container>
        } @loading {
          <app-loading class="loading"></app-loading>
        }

        <mat-divider class="chart-splitter"></mat-divider>

        @defer (on immediate) {
          <app-eps-rev-chart-container
            [ticker]="company.ticker"
            [inRequest]="(companyFacade.epsPdfInRequest$ | async) === true"
            [isDark]="(uiFacade.isDarkTheme$ | async) === true"
            [sectionName]="guardEpsPdfChart()"
          ></app-eps-rev-chart-container>
        } @loading {
          <app-loading class="loading"></app-loading>
        }
      </section>
    </div>
    <!-- </ng-template>
  </app-user-section-access> -->
  }
}
